import { ApiError } from "./client";

// The body of a successful call; failures throw `ApiError` from the client's middleware.
export async function body<T>(p: Promise<{ data?: T }>): Promise<T> {
  return (await p).data as T;
}

// Retries a network failure or a 5xx with backoff; a 4xx is the server's answer and is thrown at once.
export async function retrying<T>(call: () => Promise<T>, attempts = 4): Promise<T> {
  for (let i = 0; ; i++) {
    try {
      return await call();
    } catch (e) {
      if (e instanceof DOMException && e.name === "AbortError") throw e;
      if ((e instanceof ApiError && e.status < 500) || i === attempts - 1) throw e;
      await new Promise((ok) => setTimeout(ok, 1000 * 2 ** i));
    }
  }
}
